import React from "react";

const buttonStyles = {
  padding: "8px 16px",
  backgroundColor: "#007bff",
  color: "white",
  border: "none",
  borderRadius: "4px",
  cursor: "pointer",
  fontSize: "14px",
};

const Button = ({ onClick, children }) => {
  return (
    <button onClick={onClick} style={buttonStyles}>
      {children}
    </button>
  );
};

export default Button;
